import type { SenderRunPresetInput } from '@/api/sender-presets';

function text(value: string | null | undefined): string {
	return (value ?? '').trim();
}

/** Step 1 leave confirmation: any edit versus the loaded draft, including a cleared name. */
export function isScenarioDraftDirty(draft: SenderRunPresetInput, initial: SenderRunPresetInput): boolean {
	if (text(draft.name) !== text(initial.name)) return true;
	if (draft.apkDeliveryMethod !== initial.apkDeliveryMethod) return true;
	if (text(draft.caption) !== text(initial.caption)) return true;
	if (text(draft.buildId) !== text(initial.buildId)) return true;
	if (text(draft.externalChannelUrl) !== text(initial.externalChannelUrl)) return true;
	if ((draft.externalChannelMode ?? 'latest_message') !== (initial.externalChannelMode ?? 'latest_message')) return true;
	if (draft.audienceFilter !== initial.audienceFilter) return true;
	if (Boolean(draft.deleteAccountAfterRun) !== Boolean(initial.deleteAccountAfterRun)) return true;
	return false;
}
